import { TD_CNC, TD_CNF, RESERVE } from 'Constants/imageUrls';

const getMeetingObj = (backgroundCss, bannerText, bannerDefaultMsg, bannerImg, bannerImgAlt, handler) => {
    return {
        backgroundCss,
        bannerText,
        bannerDefaultMsg,
        translationVars: {},
        bannerImg,
        bannerImgAlt,
        handler
    };
};

export const handleMeeting = (CARD_TYPE, handleReserveDetails, handleTestDriveDetails) => {
    let meetingObj = {};

    switch (CARD_TYPE) {
        case 'TEST_DRIVE_CNF' : {
            meetingObj = getMeetingObj(
                'confirmed',
                'meetingDetailsTestDriveCnf',
                'Test drive Confirmed',
                TD_CNF,
                'test_drive_status',
                handleTestDriveDetails);
            break;
        }

        case 'TEST_DRIVE_CNC' : {
            meetingObj = getMeetingObj(
                'cancelled',
                'meetingDetailsTestDriveCnc',
                'Test drive Cancelled',
                TD_CNC,
                'test_drive_status',
                handleTestDriveDetails);
            break;
        }

        case 'STORE_VISIT_CNF' : {
            meetingObj = getMeetingObj(
                'confirmed',
                'meetingDetailsStoreVisitCnf',
                'Store visit Confirmed',
                TD_CNF,
                'store_visit_status',
                handleTestDriveDetails);
            break;
        }

        case 'STORE_VISIT_CNC' : {
            meetingObj = getMeetingObj(
                'cancelled',
                'meetingDetailsStoreVisitCnc',
                'Store visit Cancelled',
                TD_CNC,
                'store_visit_status',
                handleTestDriveDetails);
            break;
        }

        case 'RESERVE' : {
            meetingObj = getMeetingObj(
                'confirmed',
                'reserveDetails',
                'Reserved by you',
                RESERVE,
                'reservation_status',
                handleReserveDetails);
            break;
        }
    }
    return meetingObj;
};
